/**
 * @desc: - 中奖号码组件
 * @param  {[string]} className : [背景className]
 * @param  {[string]} issue :     [当前销售期号]
 * @author: circle
 */
import React from 'react';
import ReactDOM from 'react-dom'
export default class numList extends React.Component {

  constructor(props) {
    super(props);
    this.makeIssueTile = this.makeIssueTile.bind(this)
  }

  // 生成期数号码
  makeIssueTile(){
    const { alais, issue } = this.props;
    let result = issue;
    if(alais == "pk10"){
      result = "第" + result + "期"
    }
    return result;
  }

  render() {

    const {rank, alais, status} = this.props;
    const displayRank = rank || ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10'];
    return (
      <div className='rank'>
        {
          alais == 'pk10' ? <div className='left'><span/></div> : null
        }
        <span className='issue'>{this.makeIssueTile()}</span>
        <div className='rank-no'>
          {
            displayRank.map((item, index) => <span key={index} className={'num' + item}></span>)
          }
          {
            alais == 'pk10' ? <span className='last' /> : null
          }
        </div>
        {
          alais == 'pk10' ? <div className='right'></div> : null
        }
        {
          alais == 'pk10' ? <div className={status == 1 ? 'traffic green' : 'traffic red'}><ul><li/><li/><li/></ul><span/></div> : null
        }
      </div>
    );
  }
}